<template>
  <div>
    <PageTitle
      title="Dashboard"
      :salectfilter="true"
      @selectItemFilter="selectItemssamples"
      :hasBreadcrumbs="false"
    />
    <v-container fluid class="lighten-12 content container">
      <v-row>
        <v-col cols="12" xs="12" sm="12" md="9" lg="9">
          <v-row class="progressCustomersRow">
            <v-col
              cols="12"
              xs="12"
              sm="4"
              md="3"
              lg="3"
              style="cursor: pointer"
            >
              <div @click="$router.push('customer')">
                <v-card class="progressCustomers">
                  <div><h6 class="progressText">Customers</h6></div>
                  <v-row>
                    <v-col
                      cols="6"
                      xs="6"
                      sm="6"
                      md="6"
                      lg="6"
                      class="colsAlignment"
                    >
                      <div>
                        <v-img
                          class="totalCustImage"
                          src="@/assets/5.png"
                        ></v-img>
                      </div>
                    </v-col>
                    <v-col
                      cols="6"
                      xs="6"
                      sm="6"
                      md="6"
                      lg="6"
                      class="colsAlignment"
                    >
                      <div>
                        <h6 class="totalText">
                          {{ dashBoardSummary.total_customers }} Customers
                          <br />
                          {{ dashBoardSummary.total_suppliers }} Suppliers
                        </h6>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </div>
            </v-col>

            <v-col
              cols="12"
              xs="12"
              sm="4"
              md="3"
              lg="3"
              style="cursor: pointer"
            >
              <div @click="$router.push('sales')">
                <v-card class="progressSales mr-2">
                  <div><h6 class="progressText">Sales</h6></div>
                  <v-row>
                    <v-col
                      cols="6"
                      xs="6"
                      sm="6"
                      md="6"
                      lg="6"
                      class="colsAlignment"
                    >
                      <div>
                        <v-img
                          class="totalCustImage"
                          src="@/assets/4.png"
                        ></v-img>
                      </div>
                    </v-col>
                    <v-col
                      cols="6"
                      xs="6"
                      sm="6"
                      md="6"
                      lg="6"
                      class="colsAlignment"
                    >
                      <div>
                        <h6 class="totalText">
                          {{ dashBoardSummary.sales_amount | formatCurrency }}
                          <br />
                          {{ dashBoardSummary.sales_count }} Sale
                        </h6>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </div>
            </v-col>

            <v-col
              cols="12"
              xs="12"
              sm="4"
              md="3"
              lg="3"
              style="cursor: pointer"
            >
              <div @click="$router.push('purchase')">
                <v-card class="progressPurchases">
                  <div><h6 class="progressText">Purchases</h6></div>
                  <v-row>
                    <v-col
                      cols="6"
                      xs="6"
                      sm="6"
                      md="6"
                      lg="6"
                      class="colsAlignment"
                    >
                      <div>
                        <v-img
                          class="totalCustImage"
                          src="@/assets/purchases.png"
                        ></v-img>
                      </div>
                    </v-col>
                    <v-col
                      cols="6"
                      xs="6"
                      sm="6"
                      md="6"
                      lg="6"
                      class="colsAlignment"
                    >
                      <div>
                        <h6 class="totalText">
                          {{
                            dashBoardSummary.purchase_amount | formatCurrency
                          }}
                          <br />
                          {{ dashBoardSummary.purchase_count }}
                          Purchases
                        </h6>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </div>
            </v-col>

            <v-col
              cols="12"
              xs="12"
              sm="4"
              md="3"
              lg="3"
              style="cursor: pointer"
            >
              <div @click="$router.push('expenses')">
                <v-card class="progressExpenses">
                  <div><h6 class="progressText">Expenses</h6></div>
                  <v-row>
                    <v-col
                      cols="6"
                      xs="6"
                      sm="6"
                      md="6"
                      lg="6"
                      class="colsAlignment"
                    >
                      <div>
                        <v-img
                          class="totalCustImage"
                          src="@/assets/expenses.png"
                        ></v-img>
                      </div>
                    </v-col>
                    <v-col
                      cols="6"
                      xs="6"
                      sm="6"
                      md="6"
                      lg="6"
                      class="colsAlignment"
                    >
                      <div>
                        <h6 class="totalText">
                          {{ dashBoardSummary.expense_amount | formatCurrency }}
                          <br />
                          {{ dashBoardSummary.expense_count }}
                          Expenses
                        </h6>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </div>
            </v-col>
          </v-row>
          <v-row class="listAlignment">
            <v-col sm="12" md="6" lg="6" class="listDataAlign">
              <v-card class="lighten-12">
                <v-row>
                  <v-col sm="12" md="7" lg="7">
                    <div class="d-flex">
                      <span>
                        <h4 class="ml-3 mt-1">
                          {{ selectedPeriodRangeCustomer }} Customers
                        </h4>
                      </span>
                    </div>
                  </v-col>
                  <v-col sm="5" md="5" lg="5">
                    <div class="mr-3">
                      <v-select
                        :items="items"
                        item-text="title"
                        v-model="selectedPeriodRangeCustomer"
                        label="Date Range"
                        dense
                        @input="setTopCustomers"
                        solo
                      ></v-select>
                    </div>
                  </v-col>
                </v-row>

                <v-data-table
                  :fixed-header="true"
                  :headers="CustomerColumn"
                  :items="CustomerData"
                  item-key="id"
                  hide-default-footer
                >
                  <template v-slot:item.customer.image="{ item }">
                    <v-list-item class="px-0">
                      <v-list-item-avatar color="primary" size="25">
                        <v-img
                          v-if="item.customer.image"
                          :src="item.image"
                        ></v-img>
                        <span
                          v-else
                          class="white--text subtitle-2 text-uppercase"
                        >
                          {{ item.customer.name.charAt(0) }}
                        </span>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title>{{
                          item.customer.name
                        }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
            <v-col sm="12" md="6" lg="6" class="listDataAlign"
              ><v-card class="lighten-12 card-content" height="100%">
                <v-row>
                  <v-col sm="12" md="7" lg="7">
                    <div class="d-flex">
                      <span>
                        <h4 class="ml-3 mt-1">
                          {{ selectedPeriodProducts }} Products
                        </h4>
                      </span>
                    </div>
                  </v-col>

                  <v-col sm="5" md="5" lg="5">
                    <div class="mr-3">
                      <v-select
                        :items="items"
                        item-text="title"
                        v-model="selectedPeriodProducts"
                        label="Date Range"
                        dense
                        @input="setProducts"
                        solo
                      ></v-select>
                    </div>
                  </v-col>
                </v-row>

                <v-data-table
                  :fixed-header="true"
                  :headers="ProductColumn"
                  :items="productData"
                  item-key="id"
                  hide-default-footer
                  class="dataTableAlignment"
                >
                  <template v-slot:item.product.image="{ item }">
                    <v-list-item class="px-0 listItemSize">
                      <v-list-item-avatar color="primary" size="25">
                        <v-img v-if="item.image" :src="item.image"></v-img>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title>{{ i }}</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-content> </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </v-col>

        <v-col
          cols="12"
          xs="12"
          sm="12"
          md="3"
          lg="3"
          class="mt-3 sideOptionBorder"
        >
          <v-card class="sideOption">
            <v-row>
              <v-col cols="12" xs="12" sm="12" md="6" lg="10">
                <v-list-item-avatar size="48px" color="primary" class="ml-12">
                  <img
                    v-if="user.image"
                    :src="user.image"
                    height="48"
                    width="48"
                    class="image"
                  />
                  <v-avatar v-else size="16px" item color="primary">
                    <v-img class="img-100" src="@/assets/user.png"> </v-img>
                  </v-avatar>
                </v-list-item-avatar>
              </v-col>
            </v-row>
            <div>
              <h6 class="userWelcome">
                Welcome
                {{
                  user.first_name.charAt(0).toUpperCase() +
                  user.first_name.substring(1)
                }}
                !
              </h6>
            </div>
            <v-card class="sideSubCard">
              <v-row>
                <v-col
                  cols="12"
                  xs="12"
                  sm="12"
                  md="6"
                  lg="6"
                  @click="$router.push('product-list')"
                  style="cursor: pointer"
                  class="d-flex justify-center"
                >
                  <v-card class="stockCard">
                    <v-col>
                      <v-img class="img-101" src="@/assets/stock.png"></v-img>
                      <div><h6 class="sideMenuData">Stocks</h6></div>
                    </v-col>
                  </v-card>
                </v-col>
                <v-col
                  cols="12"
                  xs="12"
                  sm="12"
                  md="6"
                  lg="6"
                  @click="$router.push('product')"
                  style="cursor: pointer"
                  class="d-flex justify-center"
                >
                  <v-card class="productCard">
                    <v-col>
                      <v-img class="img-101" src="@/assets/product.png"></v-img>
                      <div><h6 class="sideMenuData">Products</h6></div>
                    </v-col>
                  </v-card>
                </v-col>
              </v-row>
              <v-row class="cardRowAlignment">
                <v-col
                  cols="12"
                  xs="12"
                  sm="12"
                  md="6"
                  lg="6"
                  @click="$router.push('cheque')"
                  style="cursor: pointer"
                  class="d-flex justify-center"
                >
                  <v-card class="chequeCard">
                    <v-col>
                      <v-img class="img-101" src="@/assets/cheque.png"></v-img>
                      <div><h6 class="sideMenuData">Cheque</h6></div>
                    </v-col>
                  </v-card>
                </v-col>
                <v-col
                  cols="12"
                  xs="12"
                  sm="12"
                  md="6"
                  lg="6"
                  @click="$router.push('daily-stock')"
                  style="cursor: pointer"
                  class="d-flex justify-center"
                >
                  <v-card class="availableStockCard">
                    <v-col>
                      <v-img
                        class="img-101"
                        src="@/assets/available.png"
                      ></v-img>
                      <div><h6 class="sideMenuData">Available Stock</h6></div>
                    </v-col>
                  </v-card>
                </v-col>
              </v-row>
              <v-row class="cardRowAlignment">
                <v-col
                  cols="12"
                  xs="12"
                  sm="12"
                  md="6"
                  lg="6"
                  @click="$router.push('supplier')"
                  style="cursor: pointer"
                  class="d-flex justify-center"
                >
                  <v-card class="suppliersCard">
                    <v-col>
                      <v-img
                        class="img-101"
                        src="@/assets/supplier.png"
                      ></v-img>
                      <div><h6 class="sideMenuData">Suppliers</h6></div>
                    </v-col>
                  </v-card>
                </v-col>
                <v-col
                  cols="12"
                  xs="12"
                  sm="12"
                  md="6"
                  lg="6"
                  @click="$router.push('shop')"
                  style="cursor: pointer"
                  class="d-flex justify-center"
                >
                  <v-card class="shopsCard">
                    <v-col>
                      <v-img class="img-101" src="@/assets/shop.png"></v-img>
                      <div><h6 class="sideMenuData">Shops</h6></div>
                    </v-col>
                  </v-card>
                </v-col>
              </v-row>
              <v-row class="cardRowAlignment">
                <v-col
                  cols="12"
                  xs="12"
                  sm="12"
                  md="6"
                  lg="6"
                  @click="$router.push('payment')"
                  style="cursor: pointer"
                  class="d-flex justify-center"
                >
                  <v-card class="paymentsCard">
                    <v-col>
                      <v-img class="img-101" src="@/assets/payment.png"></v-img>
                      <div><h6 class="sideMenuData">Payments</h6></div>
                    </v-col>
                  </v-card>
                </v-col>

                <v-col
                  cols="12"
                  xs="12"
                  sm="12"
                  md="6"
                  lg="6"
                  @click="$router.push('stock-transfer')"
                  style="cursor: pointer"
                  class="d-flex justify-center"
                >
                  <v-card class="transferCard">
                    <v-col>
                      <v-img
                        class="img-101"
                        src="@/assets/transfer.png"
                      ></v-img>
                      <div><h6 class="sideMenuData">Transfer</h6></div>
                    </v-col>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="lineGraphAlignment">
        <v-col sm="12" md="6" lg="6" v-if="chartVisible3" class="listDataAlign">
          <Chart
            :selectedPeriodRange="selectedPeriodRangePurchasewarehouse"
            :itemsData="itemsData"
            :options="chartOptions"
            :series="series2"
            :Title="' WareHouse Purchase'"
            :ChartType="'bar'"
            @LoadData="getPurchaseChartDataWarehouse"
          />
        </v-col>

        <v-col sm="12" md="6" lg="6" v-if="chartVisible4" class="listDataAlign">
          <Chart
            :selectedPeriodRange="selectedPeriodRangeSalesShop"
            :itemsData="itemsData"
            :options="chartOptions1"
            :Title="'Shop Sales'"
            :series="series3"
            :ChartType="'bar'"
            @LoadData="getSalesShopChartData"
          />
        </v-col>
      </v-row>

      <v-row class="mt-6 lineGraphAlignment">
        <v-col
          sm="12"
          md="6"
          lg="6"
          v-if="chartVisible"
          style="margin-top: -40px"
          class="purchaseGraph"
        >
          <Chart
            :selectedPeriodRange="selectedPeriodRangePurchase"
            :itemsData="itemsData"
            :options="options1"
            :series="series1"
            :Title="'Purchase'"
            @LoadData="getPurchaseChartData"
          />
        </v-col>

        <v-col sm="12" md="6" lg="6" v-if="chartVisible2" class="purchaseGraph">
          <Chart
            :selectedPeriodRange="selectedPeriodRangeSales"
            :itemsData="itemsData"
            :options="options"
            :Title="'Sales'"
            :series="series"
            @LoadData="getSalesChartData"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
// Charts

import Chart from './Chart/chart.vue';
import LineChart from '@/components/Charts/LineChart';
import ColumnChart from '@/components/Charts/ColumnChart';
import DateRangeFilter from '@/components/base/DateRangeFilter';
import CategoryPieChart from './CategoryPieChart';
import SaleProductPieChart from './SaleProductPieChart';
import TopCustomers from './TopCustomersList';
// import TableList from "./Table/index";

import { mapState } from 'vuex';
import axios from '@/plugins/axios';

export default {
  name: 'Home',
  data: () => ({
    time: new Date().toISOString().substr(11, 8),
    date: new Date().toISOString().substr(0, 10),
    chartVisible: false,
    chartVisible3: false,
    chartVisible4: false,
    SalesShopData: [],
    selectedPeriodRangeCustomer: 'Last 7 Days',
    selectedPeriodProducts: 'Last 7 Days',
    selectedPeriodRangePurchasewarehouse: 'Last 7 Days',
    selectedPeriodRangeSalesShop: 'Last 7 Days',
    chartVisible2: false,
    chartOptions1: {
      chart: {
        type: 'bar',
        height: 430,
      },
      plotOptions: {
        bar: {
          horizontal: true,
          dataLabels: {
            position: 'top',
          },
        },
      },
      dataLabels: {
        enabled: true,
        offsetX: -20,
        style: {
          fontSize: '5px',
          colors: ['#fff'],
        },
      },
      stroke: {
        show: true,
        width: 1,
        colors: ['#fff'],
      },
      xaxis: {
        categories: [],
      },
    },
    chartOptions: {
      chart: {
        type: 'bar',
        height: 430,
      },
      fill: {
        colors: ['#1A73E8', '#00e396'],
      },
      plotOptions: {
        bar: {
          horizontal: true,
          dataLabels: {
            position: 'top',
          },
        },
      },
      dataLabels: {
        enabled: true,
        offsetX: -6,
        style: {
          fontSize: '5px',
          colors: ['#fff'],
        },
      },
      stroke: {
        show: true,
        width: 1,
        colors: ['#fff'],
      },
      xaxis: {
        categories: [],
      },
    },
    options: {
      chart: {
        id: 'vuechart-example1',
      },
      colors: ['#699834'],
      xaxis: {
        categories: [],
      },
    },
    options1: {
      chart: {
        id: 'vuechart-example',
      },
      xaxis: {
        categories: [],
      },
    },
    series1: [
      {
        name: 'series-1',
        data: [],
      },
    ],
    series2: [
      {
        name: 'series-1',
        data: [],
      },
    ],

    series3: [
      {
        data: [44, 55, 41, 64, 22, 43, 21],
      },
      {
        data: [53, 32, 33, 52, 13, 44, 32],
      },
    ],
    series: [
      {
        name: 'series-1',
        data: [],
      },
    ],
    dashBoardSummary: {},
    summaryRange: 0,
    salesData: {},
    PurchaseData: {},
    noOfCustomers: 0,
    CustomerData: [],
    warehousePurchaseData: [],
    productData: [],

    CustomerColumn: [
      {
        text: 'Name',
        value: 'customer.image',
      },
      {
        text: 'Reference Number',
        value: 'customer.reference_number',
      },

      {
        text: 'Total Sales',
        value: 'total',
      },
    ],
    ProductColumn: [
      {
        text: 'Image',
        value: 'product.image',
        align: 'center',
      },
      {
        text: 'Name',
        value: 'product.name',
        align: 'center',
      },

      {
        text: 'Total Sales Quantity',
        value: 'quantity',
        align: 'center',
      },
    ],
    selectedPeriod: 'Today',
    selectedPeriodRangePurchase: 'Last 7 Days',
    selectedPeriodRangeSales: 'Last 7 Days',
    itemsData: [
      { title: 'Last 7 Days' },
      { title: 'Last 4 Week' },
      { title: 'Last 12 Month' },
    ],
    items: [
      { title: 'Today' },
      { title: 'Last 7 Days' },
      { title: 'This Month' },
      { title: 'This Year' },
    ],
  }),
  computed: {
    ...mapState('user', ['user']),
    ...mapState(['theme']),
  },
  components: {
    LineChart,
    ColumnChart,
    DateRangeFilter,
    CategoryPieChart,
    SaleProductPieChart,
    TopCustomers,
    // TableList,
    Chart,
  },
  methods: {
    getUser() {
      let userId = this.$route.params.id;

      this.$store
        .dispatch('user/GetSingleUser', userId)
        .then((res) => {
          this.succeeed = true;

          this.user = new User().initialise(res.data);
          if (this.user.image) {
            this.user.image = this.user.image + '?t=' + Date.now();
          }
        })
        .catch((err) => {
          this.messages.push(err.data);
          // this.$router.push("/pages/404");
        });
    },

    getPurchaseChartDataWarehouse(item) {
      this.chartVisible3 = false;
      this.selectedPeriodRangePurchasewarehouse = item;
      this.getwarehousePurchaseChart();
    },
    getSalesShopChartData(item) {
      this.chartVisible4 = false;
      this.selectedPeriodRangeSalesShop = item;
      this.getsalesShop();
    },
    getSalesChartData(item) {
      this.chartVisible2 = false;
      this.selectedPeriodRangeSales = item;
      this.getSalesChart();
    },
    setProducts(item) {
      this.selectedPeriodProducts = item;
      this.getTopProductss();
    },
    setTopCustomers(item) {
      this.selectedPeriodRangeCustomer = item;
      this.getTopCustomers();
    },
    getPurchaseChartData(item) {
      this.chartVisible = false;
      this.selectedPeriodRangePurchase = item;
      this.getPurchaseChart();
    },
    selectItemssamples(item) {
      this.selectedPeriod = item;
      this.getDashboardSummary();
    },
    getDashboardSummary() {
      axios
        .get(`dashboard/summary?range=${this.getRange()}`)
        .then((resp) => {
          this.dashBoardSummary = resp.data.data;
        })
        .catch((err) => {
          reject(err.response);
        });
    },
    getsalesShop() {
      axios
        .get(
          `dashboard/chart/shop-sale-bar-chart?range=${this.getRangeValueSalesShop()}`,
        )
        .then((resp) => {
          this.SalesShopData = resp.data.data;
          this.series3 = this.SalesShopData.series;
          let self = this;
          this.chartOptions1.xaxis.categories = this.SalesShopData.categories;

          setTimeout(() => {
            this.chartVisible4 = true;
          }, 400);
        })
        .catch((err) => {
          reject(err.response);
        });
    },
    getwarehousePurchaseChart() {
      axios
        .get(
          `dashboard/chart/warehouse-purchase-bar-chart?range=${this.getRangeValuePurchaseWarehouse()}`,
        )
        .then((resp) => {
          this.warehousePurchaseData = resp.data.data;
          this.series2 = this.warehousePurchaseData.series;
          let self = this;
          this.chartOptions.xaxis.categories =
            this.warehousePurchaseData.categories;

          setTimeout(() => {
            this.chartVisible3 = true;
          }, 400);
        })
        .catch((err) => {
          reject(err.response);
        });
    },
    getPurchaseChart() {
      axios
        .get(
          `dashboard/chart/purchase-area-chart?range=${this.getRangeValuePurchase()}`,
        )
        .then((resp) => {
          this.PurchaseData = resp.data.data;
          this.series1 = this.PurchaseData.series;
          let self = this;
          this.options1.xaxis.categories = this.PurchaseData.categories;

          setTimeout(() => {
            this.chartVisible = true;
          }, 400);
        })
        .catch((err) => {
          reject(err.response);
        });
    },
    getSalesChart() {
      axios
        .get(
          `dashboard/chart/sale-area-chart?range=${this.getRangeValueSales()}`,
        )
        .then((resp) => {
          this.salesData = resp.data.data;
          this.series = this.salesData.series;
          let self = this;
          self.options.xaxis.categories = this.salesData.categories;

          setTimeout(() => {
            this.chartVisible2 = true;
          }, 400);
        })
        .catch((err) => {
          reject(err.response);
        });
    },
    getTopProductss() {
      axios
        .get(
          `dashboard/top-product-revenue?range=${this.getRangeValueProducts()}`,
        )
        .then((resp) => {
          this.productData = resp.data.data;
        })
        .catch((err) => {
          reject(err.response);
        });
    },
    getTopCustomers() {
      axios
        .get(`dashboard/top-customer?range=${this.getRangeValueCustomers()}`)
        .then((resp) => {
          this.CustomerData = resp.data.data;
        })
        .catch((err) => {
          reject(err.response);
        });
    },
    getRange() {
      if (this.selectedPeriod == 'Today') {
        return 'today';
      } else if (this.selectedPeriod == 'Last 7 Days') {
        return 'last7Days';
      } else if (this.selectedPeriod == 'This Month') {
        return 'thisMonth';
      } else if (this.selectedPeriod == 'This Year') {
        return 'thisYear';
      }
    },
    getRangeValueProducts() {
      if (this.selectedPeriodProducts == 'Today') {
        return 'today';
      } else if (this.selectedPeriodProducts == 'Last 7 Days') {
        return 'last7Days';
      } else if (this.selectedPeriodProducts == 'This Month') {
        return 'thisMonth';
      } else if (this.selectedPeriodProducts == 'This Year') {
        return 'thisYear';
      }
    },
    getRangeValueCustomers() {
      if (this.selectedPeriodRangeCustomer == 'Today') {
        return 'today';
      } else if (this.selectedPeriodRangeCustomer == 'Last 7 Days') {
        return 'last7Days';
      } else if (this.selectedPeriodRangeCustomer == 'This Month') {
        return 'thisMonth';
      } else if (this.selectedPeriodRangeCustomer == 'This Year') {
        return 'thisYear';
      }
    },
    getRangeValueSalesShop() {
      if (this.selectedPeriodRangeSalesShop == 'Today') {
        return 'today';
      } else if (this.selectedPeriodRangeSalesShop == 'Last 7 Days') {
        return 'last7Days';
      } else if (this.selectedPeriodRangeSalesShop == 'Last 4 Week') {
        return 'last4Week';
      } else if (this.selectedPeriodRangeSalesShop == 'Last 12 Month') {
        return 'last12Month';
      }
    },
    getRangeValueSales() {
      if (this.selectedPeriodRangeSales == 'Today') {
        return 'today';
      } else if (this.selectedPeriodRangeSales == 'Last 7 Days') {
        return 'last7Days';
      } else if (this.selectedPeriodRangeSales == 'Last 4 Week') {
        return 'last4Week';
      } else if (this.selectedPeriodRangeSales == 'Last 12 Month') {
        return 'last12Month';
      }
    },
    getRangeValuePurchaseWarehouse() {
      if (this.selectedPeriodRangePurchasewarehouse == 'Today') {
        return 'today';
      } else if (this.selectedPeriodRangePurchasewarehouse == 'Last 7 Days') {
        return 'last7Days';
      } else if (this.selectedPeriodRangePurchasewarehouse == 'Last 4 Week') {
        return 'last4Week';
      } else if (this.selectedPeriodRangePurchasewarehouse == 'Last 12 Month') {
        return 'last12Month';
      }
    },
    getRangeValuePurchase() {
      if (this.selectedPeriodRangePurchase == 'Today') {
        return 'today';
      } else if (this.selectedPeriodRangePurchase == 'Last 7 Days') {
        return 'last7Days';
      } else if (this.selectedPeriodRangePurchase == 'Last 4 Week') {
        return 'last4Week';
      } else if (this.selectedPeriodRangePurchase == 'Last 12 Month') {
        return 'last12Month';
      }
    },
    getRangeText() {
      if (this.summaryRange == 0) {
        return 'Today';
      } else if (this.summaryRange == 1) {
        return 'Last 7 Days';
      } else if (this.summaryRange == 2) {
        return 'This Month';
      } else if (this.summaryRange == 3) {
        return 'This Year';
      }
    },
    getCustomerPercentage(total, active) {
      let result = (active / total) * 100;
      if (result % 1 == 0) {
        return result;
      } else {
        return result.toFixed(2);
      }
    },
  },

  mounted() {},
  created() {
    this.$store.commit('REMOVE_FILTERDATAS');
    this.$store.commit('UPDATE_PAGINATION_PAGE_SIZE', 15);
    this.getDashboardSummary();
    this.getTopCustomers();
    this.getTopProductss();
    this.getSalesChart();
    this.getPurchaseChart();
    this.getwarehousePurchaseChart();
    this.getsalesShop();
    //this.getUser();
  },
};
</script>
<style scoped>
.container {
  background-color: white;
}

.sideOption {
  width: 93%;
  height: 101%;
  border-radius: 100px;
  background-color: #edf2f4;
  text-align: center;
  margin: auto;
}

.img-100 {
  width: 60px;
  height: 60px;
  margin-left: 45%;
}

.userWelcome {
  font-size: 16px;
  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
  text-align: center;
  font-weight: 600;
  margin-bottom: 4px;
}

.sideMenuData {
  font-size: 12px;
  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
  text-align: center;
  font-weight: 600;
}

.sideSubCard {
  width: 90%;
  margin: auto;
}

.stockCard {
  width: 81%;
  height: 98%;
  background-color: #ffe0df;
}

.productCard {
  width: 81%;
  height: 98%;
  background-color: #e0ffde;
}

.chequeCard {
  width: 81%;
  height: 98%;
  background-color: #ffebd1;
}

.availableStockCard {
  width: 81%;
  height: 98%;
  background-color: #d8f6ff;
}

.suppliersCard {
  width: 81%;
  height: 98%;
  background-color: #bbadff;
}

.shopsCard {
  width: 81%;
  height: 98%;
  background-color: #ffef9f;
}

.paymentsCard {
  width: 81%;
  height: 98%;
  background-color: #ffc4d6;
}

.transferCard {
  width: 81%;
  height: 98%;
  background-color: #c1fba4;
}

.progressCustomers {
  width: 100%;
  height: 120px;
}

.progressSales {
  width: 100%;
  height: 120px;
  background-color: #d8f6ff;
}

.progressPurchases {
  width: 100%;
  height: 120px;
  background-color: #fff;
}

.progressExpenses {
  width: 100%;
  height: 120px;
  background-color: #e0ffde;
}

.cardRowAlignment {
  margin-top: 12px;
}

.progressText {
  font-family:
    -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu,
    Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  font-weight: 600;
  font-size: 90%;
  color: #03045e;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
}

.totalText {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  font-weight: 600;

  font-size: 90%;
  color: #000000;
}

.img-101 {
  width: 40px !important;
  margin: auto;
  /* margin-left: 8px !important; */
}

.totalCustImage {
  width: 60px;
  height: 60px;
}

.listContent {
  background: #fffefe !important;
  box-sizing: border-box !important;
  border: 1px solid #afa9a9 !important;
  box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25) !important;
}

.productList {
  color: #fbf8cc;
}

.listItemSize {
  height: 10px;
}

.dataTableAlignment {
  align-content: center;
}
/*.v-sheet.v-card:not(.v-sheet--outlined)*/
.progressCustomersRow .v-sheet.v-card {
  border-radius: 15px !important;
  -webkit-box-shadow: -2px 6px 22px -14px rgba(105, 105, 105, 1) !important;
  -moz-box-shadow: -2px 6px 22px -14px rgba(105, 105, 105, 1) !important;
  box-shadow: -2px 6px 22px -14px rgba(105, 105, 105, 1) !important;
}

/* .listDataAlign {
  border-radius: 15px !important;
  -webkit-box-shadow: -2px 6px 22px -7px rgba(105, 105, 105, 1) !important;
  -moz-box-shadow: -2px 6px 22px -7px rgba(105, 105, 105, 1) !important;
  box-shadow: -2px 6px 22px -7px rgba(105, 105, 105, 1) !important;
} */

.lineGraphAlignment {
  width: 100%;
  margin-left: 1px;
  display: flex;
  align-content: space-between;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  flex-direction: row;
}

/* .purchaseGraph {
  border-radius: 15px !important;
  -webkit-box-shadow: -2px 6px 22px -7px rgba(105, 105, 105, 1) !important;
  -moz-box-shadow: -2px 6px 22px -7px rgba(105, 105, 105, 1) !important;
  box-shadow: -2px 6px 22px -7px rgba(105, 105, 105, 1) !important;
} */

@media screen and (min-width: 992px) {
  .purchaseGraph {
    margin-top: -40px !important;
  }
}

.listAlignment {
  width: 100% !important;
  display: flex;
  justify-content: space-between;
  margin-left: 1px;
}

.sideOptionBorder .v-sheet.v-card {
  border-radius: 15px !important;
  /* -webkit-box-shadow: -2px 6px 22px -7px rgba(105, 105, 105, 1) !important;
  -moz-box-shadow: -2px 6px 22px -7px rgba(105, 105, 105, 1) !important;
  box-shadow: -2px 6px 22px -7px rgba(105, 105, 105, 1) !important; */
}

.dataTable {
  height: 1% !important;
}

.textSize {
  font-weight: 900;
}

.colsAlignment {
  display: flex;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
}
</style>
